<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="width" :height="height" viewBox="0 0 36 36">
        <defs>
            <clipPath id="clip-Colapse">
                <rect width="36" height="36"/>
            </clipPath>
        </defs>
        <g id="Colapse" clip-path="url(#clip-Colapse)">
            <rect width="36" height="36" fill="rgba(81,91,96,0)"/>
            <g id="Group_13308" data-name="Group 13308" transform="translate(6 6)">
                <g id="Group_13361" data-name="Group 13361" transform="translate(-6 -6)">
                    <g id="Ellipse_975" data-name="Ellipse 975" fill="none" class="svg-stroke-block-color" stroke-miterlimit="10" stroke-width="1">
                        <circle cx="18" cy="18" r="18" stroke="none"/>
                        <circle cx="18" cy="18" r="17.5" fill="none"/>
                    </g>
                </g>
                <path id="Path_33" data-name="Path 33" d="M0,0H36V36H0Z" transform="translate(-6 -6)"  opacity="0"/>
                <path id="Path_34" data-name="Path 34" d="M7.41,15.41,12,10.83l4.59,4.58L18,14,12,8,6,14Z" class="svg-secondary-color"/>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "CollapseIcon",
    props: {
        width: {
            type: Number,
            default: 30,
        },

        height: {
            type: Number,
            default: 30
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/CollapseIcon.vue